import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MetroService {
    metroList$: Observable<any> = of(this.getMetroData().reduce((obj, el) => ({...obj, ...{[el["code"]]: el["name"]}}), {}));

    getMetroData() {
        const data = [
            { name: 'Abilene, TX', code: '10180' },
            { name: 'Akron, OH', code: '10420' },
            { name: 'Albany, GA', code: '10500' },
            { name: 'Albany, OR', code: '10540' },
            { name: 'Albany-Schenectady-Troy, NY', code: '10580' },
            { name: 'Albuquerque, NM', code: '10740' },
            { name: 'Alexandria, LA', code: '10780' },
            { name: 'Allentown-Bethlehem-Easton, PA-NJ', code: '10900' },
            { name: 'Altoona, PA', code: '11020' },
            { name: 'Amarillo, TX', code: '11100' },
            { name: 'Ames, IA', code: '11180' },
            { name: 'Anchorage, AK', code: '11260' },
            { name: 'Ann Arbor, MI', code: '11460' },
            { name: 'Anniston-Oxford-Jacksonville, AL', code: '11500' },
            { name: 'Appleton, WI', code: '11540' },
            { name: 'Asheville, NC', code: '11700' },
            { name: 'Athens-Clarke County, GA', code: '12020' },
            { name: 'Atlanta-Sandy Springs-Roswell, GA', code: '12060' },
            { name: 'Atlantic City-Hammonton, NJ', code: '12100' },
            { name: 'Auburn-Opelika, AL', code: '12220' },
            { name: 'Augusta-Richmond County, GA-SC', code: '12260' },
            { name: 'Austin-Round Rock, TX', code: '12420' },
            { name: 'Bakersfield, CA', code: '12540' },
            { name: 'Baltimore-Columbia-Towson, MD', code: '12580' },
            { name: 'Bangor, ME', code: '12620' },
            { name: 'Barnstable Town, MA', code: '12700' },
            { name: 'Baton Rouge, LA', code: '12940' },
            { name: 'Battle Creek, MI', code: '12980' },
            { name: 'Bay City, MI', code: '13020' },
            { name: 'Beaumont-Port Arthur, TX', code: '13140' },
            { name: 'Beckley, WV', code: '13220' },
            { name: 'Bellingham, WA', code: '13380' },
            { name: 'Bend-Redmond, OR', code: '13460' },
            { name: 'Billings, MT', code: '13740' },
            { name: 'Binghamton, NY', code: '13780' },
            { name: 'Birmingham-Hoover, AL', code: '13820' },
            { name: 'Bismarck, ND', code: '13900' },
            { name: 'Blacksburg-Christiansburg-Radford, VA', code: '13980' },
            { name: 'Bloomington, IL', code: '14010' },
            { name: 'Bloomington, IN', code: '14020' },
            { name: 'Bloomsburg-Berwick, PA', code: '14100' },
            { name: 'Boise City, ID', code: '14260' },
            { name: 'Boston-Cambridge-Newton, MA-NH', code: '14460' },
            { name: 'Boulder, CO', code: '14500' },
            { name: 'Bowling Green, KY', code: '14540' },
            { name: 'Bremerton-Silverdale, WA', code: '14740' },
            { name: 'Bridgeport-Stamford-Norwalk, CT', code: '14860' },
            { name: 'Brownsville-Harlingen, TX', code: '15180' },
            { name: 'Brunswick, GA', code: '15260' },
            { name: 'Buffalo-Cheektowaga-Niagara Falls, NY', code: '15380' },
            { name: 'Burlington, NC', code: '15500' },
            { name: 'Burlington-South Burlington, VT', code: '15540' },
            { name: 'California-Lexington Park, MD', code: '15680' },
            { name: 'Canton-Massillon, OH', code: '15940' },
            { name: 'Cape Coral-Fort Myers, FL', code: '15980' },
            { name: 'Cape Girardeau, MO-IL', code: '16020' },
            { name: 'Carbondale-Marion, IL', code: '16060' },
            { name: 'Carson City, NV', code: '16180' },
            { name: 'Casper, WY', code: '16220' },
            { name: 'Cedar Rapids, IA', code: '16300' },
            { name: 'Chambersburg-Waynesboro, PA', code: '16540' },
            { name: 'Champaign-Urbana, IL', code: '16580' },
            { name: 'Charleston, WV', code: '16620' },
            { name: 'Charleston-North Charleston, SC', code: '16700' },
            { name: 'Charlotte-Concord-Gastonia, NC-SC', code: '16740' },
            { name: 'Charlottesville, VA', code: '16820' },
            { name: 'Chattanooga, TN-GA', code: '16860' },
            { name: 'Cheyenne, WY', code: '16940' },
            { name: 'Chicago-Naperville-Elgin, IL-IN-WI', code: '16980' },
            { name: 'Chico, CA', code: '17020' },
            { name: 'Cincinnati, OH-KY-IN', code: '17140' },
            { name: 'Clarksville, TN-KY', code: '17300' },
            { name: 'Cleveland, TN', code: '17420' },
            { name: 'Cleveland-Elyria, OH', code: '17460' },
            { name: 'Coeur d\'Alene, ID', code: '17660' },
            { name: 'College Station-Bryan, TX', code: '17780' },
            { name: 'Colorado Springs, CO', code: '17820' },
            { name: 'Columbia, MO', code: '17860' },
            { name: 'Columbia, SC', code: '17900' },
            { name: 'Columbus, GA-AL', code: '17980' },
            { name: 'Columbus, IN', code: '18020' },
            { name: 'Columbus, OH', code: '18140' },
            { name: 'Corpus Christi, TX', code: '18580' },
            { name: 'Corvallis, OR', code: '18700' },
            { name: 'Crestview-Fort Walton Beach-Destin, FL', code: '18880' },
            { name: 'Cumberland, MD-WV', code: '19060' },
            { name: 'Dallas-Fort Worth-Arlington, TX', code: '19100' },
            { name: 'Dalton, GA', code: '19140' },
            { name: 'Danville, IL', code: '19180' },
            { name: 'Daphne-Fairhope-Foley, AL', code: '19300' },
            { name: 'Davenport-Moline-Rock Island, IA-IL', code: '19340' },
            { name: 'Dayton, OH', code: '19380' },
            { name: 'Decatur, AL', code: '19460' },
            { name: 'Decatur, IL', code: '19500' },
            { name: 'Deltona-Daytona Beach-Ormond Beach, FL', code: '19660' },
            { name: 'Denver-Aurora-Lakewood, CO', code: '19740' },
            { name: 'Des Moines-West Des Moines, IA', code: '19780' },
            { name: 'Detroit-Warren-Dearborn, MI', code: '19820' },
            { name: 'Dothan, AL', code: '20020' },
            { name: 'Dover, DE', code: '20100' },
            { name: 'Dubuque, IA', code: '20220' },
            { name: 'Duluth, MN-WI', code: '20260' },
            { name: 'Durham-Chapel Hill, NC', code: '20500' },
            { name: 'East Stroudsburg, PA', code: '20700' },
            { name: 'Eau Claire, WI', code: '20740' },
            { name: 'El Centro, CA', code: '20940' },
            { name: 'El Paso, TX', code: '21340' },
            { name: 'Elizabethtown-Fort Knox, KY', code: '21060' },
            { name: 'Elkhart-Goshen, IN', code: '21140' },
            { name: 'Elmira, NY', code: '21300' },
            { name: 'Erie, PA', code: '21500' },
            { name: 'Eugene, OR', code: '21660' },
            { name: 'Evansville, IN-KY', code: '21780' },
            { name: 'Fairbanks, AK', code: '21820' },
            { name: 'Fargo, ND-MN', code: '22020' },
            { name: 'Farmington, NM', code: '22140' },
            { name: 'Fayetteville, NC', code: '22180' },
            { name: 'Fayetteville-Springdale-Rogers, AR-MO', code: '22220' },
            { name: 'Flagstaff, AZ', code: '22380' },
            { name: 'Flint, MI', code: '22420' },
            { name: 'Florence, SC', code: '22500' },
            { name: 'Florence-Muscle Shoals, AL', code: '22520' },
            { name: 'Fond du Lac, WI', code: '22540' },
            { name: 'Fort Collins, CO', code: '22660' },
            { name: 'Fort Smith, AR-OK', code: '22900' },
            { name: 'Fort Wayne, IN', code: '23060' },
            { name: 'Fresno, CA', code: '23420' },
            { name: 'Gadsden, AL', code: '23460' },
            { name: 'Gainesville, FL', code: '23540' },
            { name: 'Gainesville, GA', code: '23580' },
            { name: 'Gettysburg, PA', code: '23900' },
            { name: 'Glens Falls, NY', code: '24020' },
            { name: 'Goldsboro, NC', code: '24140' },
            { name: 'Grand Forks, ND-MN', code: '24220' },
            { name: 'Grand Island, NE', code: '24260' },
            { name: 'Grand Junction, CO', code: '24300' },
            { name: 'Grand Rapids-Wyoming, MI', code: '24340' },
            { name: 'Grants Pass, OR', code: '24420' },
            { name: 'Great Falls, MT', code: '24500' },
            { name: 'Greeley, CO', code: '24540' },
            { name: 'Green Bay, WI', code: '24580' },
            { name: 'Greensboro-High Point, NC', code: '24660' },
            { name: 'Greenville, NC', code: '24780' },
            { name: 'Greenville-Anderson-Mauldin, SC', code: '24860' },
            { name: 'Gulfport-Biloxi-Pascagoula, MS', code: '25060' },
            { name: 'Hagerstown-Martinsburg, MD-WV', code: '25180' },
            { name: 'Hammond, LA', code: '25220' },
            { name: 'Hanford-Corcoran, CA', code: '25260' },
            { name: 'Harrisburg-Carlisle, PA', code: '25420' },
            { name: 'Harrisonburg, VA', code: '25500' },
            { name: 'Hartford-West Hartford-East Hartford, CT', code: '25540' },
            { name: 'Hattiesburg, MS', code: '25620' },
            { name: 'Hickory-Lenoir-Morganton, NC', code: '25860' },
            { name: 'Hilton Head Island-Bluffton-Beaufort, SC', code: '25940' },
            { name: 'Hinesville, GA', code: '25980' },
            { name: 'Homosassa Springs, FL', code: '26140' },
            { name: 'Hot Springs, AR', code: '26300' },
            { name: 'Houma-Thibodaux, LA', code: '26380' },
            { name: 'Houston-The Woodlands-Sugar Land, TX', code: '26420' },
            { name: 'Huntington-Ashland, WV-KY-OH', code: '26580' },
            { name: 'Huntsville, AL', code: '26620' },
            { name: 'Idaho Falls, ID', code: '26820' },
            { name: 'Indianapolis-Carmel-Anderson, IN', code: '26900' },
            { name: 'Iowa City, IA', code: '26980' },
            { name: 'Ithaca, NY', code: '27060' },
            { name: 'Jackson, MI', code: '27100' },
            { name: 'Jackson, MS', code: '27140' },
            { name: 'Jackson, TN', code: '27180' },
            { name: 'Jacksonville, FL', code: '27260' },
            { name: 'Jacksonville, NC', code: '27340' },
            { name: 'Janesville-Beloit, WI', code: '27500' },
            { name: 'Jefferson City, MO', code: '27620' },
            { name: 'Johnson City, TN', code: '27740' },
            { name: 'Johnstown, PA', code: '27780' },
            { name: 'Jonesboro, AR', code: '27860' },
            { name: 'Joplin, MO', code: '27900' },
            { name: 'Kahului-Wailuku-Lahaina, HI', code: '27980' },
            { name: 'Kalamazoo-Portage, MI', code: '28020' },
            { name: 'Kankakee, IL', code: '28100' },
            { name: 'Kansas City, MO-KS', code: '28140' },
            { name: 'Kennewick-Richland, WA', code: '28420' },
            { name: 'Killeen-Temple, TX', code: '28660' },
            { name: 'Kingsport-Bristol-Bristol, TN-VA', code: '28700' },
            { name: 'Kingston, NY', code: '28740' },
            { name: 'Knoxville, TN', code: '28940' },
            { name: 'Kokomo, IN', code: '29020' },
            { name: 'La Crosse-Onalaska, WI-MN', code: '29100' },
            { name: 'Lafayette, LA', code: '29180' },
            { name: 'Lafayette-West Lafayette, IN', code: '29200' },
            { name: 'Lake Charles, LA', code: '29340' },
            { name: 'Lake Havasu City-Kingman, AZ', code: '29420' },
            { name: 'Lakeland-Winter Haven, FL', code: '29460' },
            { name: 'Lancaster, PA', code: '29540' },
            { name: 'Lansing-East Lansing, MI', code: '29620' },
            { name: 'Laredo, TX', code: '29700' },
            { name: 'Las Cruces, NM', code: '29740' },
            { name: 'Las Vegas-Henderson-Paradise, NV', code: '29820' },
            { name: 'Lawrence, KS', code: '29940' },
            { name: 'Lawton, OK', code: '30020' },
            { name: 'Lebanon, PA', code: '30140' },
            { name: 'Lewiston, ID-WA', code: '30300' },
            { name: 'Lewiston-Auburn, ME', code: '30340' },
            { name: 'Lexington-Fayette, KY', code: '30460' },
            { name: 'Lima, OH', code: '30620' },
            { name: 'Lincoln, NE', code: '30700' },
            { name: 'Little Rock-North Little Rock-Conway, AR', code: '30780' },
            { name: 'Logan, UT-ID', code: '30860' },
            { name: 'Longview, TX', code: '30980' },
            { name: 'Longview, WA', code: '31020' },
            { name: 'Los Angeles-Long Beach-Anaheim, CA', code: '31080' },
            { name: 'Louisville–Jefferson County, KY-IN', code: '31140' },
            { name: 'Lubbock, TX', code: '31180' },
            { name: 'Lynchburg, VA', code: '31340' },
            { name: 'Macon-Bibb County, GA', code: '31420' },
            { name: 'Madera, CA', code: '31460' },
            { name: 'Madison, WI', code: '31540' },
            { name: 'Manchester-Nashua, NH', code: '31700' },
            { name: 'Manhattan, KS', code: '31740' },
            { name: 'Mankato-North Mankato, MN', code: '31860' },
            { name: 'Mansfield, OH', code: '31900' },
            { name: 'McAllen-Edinburg-Mission, TX', code: '32580' },
            { name: 'Medford, OR', code: '32780' },
            { name: 'Memphis, TN-MS-AR', code: '32820' },
            { name: 'Merced, CA', code: '32900' },
            { name: 'Miami-Fort Lauderdale-West Palm Beach, FL', code: '33100' },
            { name: 'Michigan City-La Porte, IN', code: '33140' },
            { name: 'Midland, MI', code: '33220' },
            { name: 'Midland, TX', code: '33260' },
            { name: 'Milwaukee-Waukesha-West Allis, WI', code: '33340' },
            { name: 'Minneapolis-St. Paul-Bloomington, MN-WI', code: '33460' },
            { name: 'Missoula, MT', code: '33540' },
            { name: 'Mobile, AL', code: '33660' },
            { name: 'Modesto, CA', code: '33700' },
            { name: 'Monroe, LA', code: '33740' },
            { name: 'Monroe, MI', code: '33780' },
            { name: 'Montgomery, AL', code: '33860' },
            { name: 'Morgantown, WV', code: '34060' },
            { name: 'Morristown, TN', code: '34100' },
            { name: 'Mount Vernon-Anacortes, WA', code: '34580' },
            { name: 'Muncie, IN', code: '34620' },
            { name: 'Muskegon, MI', code: '34740' },
            { name: 'Myrtle Beach-Conway-North Myrtle Beach, SC-NC', code: '34820' },
            { name: 'Napa, CA', code: '34900' },
            { name: 'Naples-Immokalee-Marco Island, FL', code: '34940' },
            { name: 'Nashville-Davidson–Murfreesboro–Franklin, TN', code: '34980' },
            { name: 'New Bern, NC', code: '35100' },
            { name: 'New Haven-Milford, CT', code: '35300' },
            { name: 'New Orleans-Metairie, LA', code: '35380' },
            { name: 'New York-Newark-Jersey City, NY-NJ-PA', code: '35620' },
            { name: 'Niles-Benton Harbor, MI', code: '35660' },
            { name: 'North Port-Sarasota-Bradenton, FL', code: '35840' },
            { name: 'Norwich-New London, CT', code: '35980' },
            { name: 'Ocala, FL', code: '36100' },
            { name: 'Ocean City, NJ', code: '36140' },
            { name: 'Odessa, TX', code: '36220' },
            { name: 'Ogden-Clearfield, UT', code: '36260' },
            { name: 'Oklahoma City, OK', code: '36420' },
            { name: 'Olympia-Tumwater, WA', code: '36500' },
            { name: 'Omaha-Council Bluffs, NE-IA', code: '36540' },
            { name: 'Orlando-Kissimmee-Sanford, FL', code: '36740' },
            { name: 'Oshkosh-Neenah, WI', code: '36780' },
            { name: 'Owensboro, KY', code: '36980' },
            { name: 'Oxnard-Thousand Oaks-Ventura, CA', code: '37100' },
            { name: 'Palm Bay-Melbourne-Titusville, FL', code: '37340' },
            { name: 'Panama City, FL', code: '37460' },
            { name: 'Parkersburg-Vienna, WV', code: '37620' },
            { name: 'Pensacola-Ferry Pass-Brent, FL', code: '37860' },
            { name: 'Peoria, IL', code: '37900' },
            { name: 'Philadelphia-Camden-Wilmington, PA-NJ-DE-MD', code: '37980' },
            { name: 'Phoenix-Mesa-Scottsdale, AZ', code: '38060' },
            { name: 'Pine Bluff, AR', code: '38220' },
            { name: 'Pittsburgh, PA', code: '38300' },
            { name: 'Pittsfield, MA', code: '38340' },
            { name: 'Pocatello, ID', code: '38540' },
            { name: 'Port St. Lucie, FL', code: '38940' },
            { name: 'Portland-South Portland, ME', code: '38860' },
            { name: 'Portland-Vancouver-Hillsboro, OR-WA', code: '38900' },
            { name: 'Prescott, AZ', code: '39140' },
            { name: 'Providence-Warwick, RI-MA', code: '39300' },
            { name: 'Provo-Orem, UT', code: '39340' },
            { name: 'Pueblo, CO', code: '39380' },
            { name: 'Punta Gorda, FL', code: '39460' },
            { name: 'Racine, WI', code: '39540' },
            { name: 'Raleigh-Cary, NC', code: '39580' },
            { name: 'Rapid City, SD', code: '39660' },
            { name: 'Reading, PA', code: '39740' },
            { name: 'Redding, CA', code: '39820' },
            { name: 'Reno, NV', code: '39900' },
            { name: 'Richmond, VA', code: '40060' },
            { name: 'Riverside-San Bernardino-Ontario, CA', code: '40140' },
            { name: 'Roanoke, VA', code: '40220' },
            { name: 'Rochester, MN', code: '40340' },
            { name: 'Rochester, NY', code: '40380' },
            { name: 'Rockford, IL', code: '40420' },
            { name: 'Rocky Mount, NC', code: '40580' },
            { name: 'Rome, GA', code: '40660' },
            { name: 'Sacramento–Roseville–Arden-Arcade, CA', code: '40900' },
            { name: 'Saginaw, MI', code: '40980' },
            { name: 'Salem, OR', code: '41420' },
            { name: 'Salinas, CA', code: '41500' },
            { name: 'Salisbury, MD-DE', code: '41540' },
            { name: 'Salt Lake City, UT', code: '41620' },
            { name: 'San Angelo, TX', code: '41660' },
            { name: 'San Antonio-New Braunfels, TX', code: '41700' },
            { name: 'San Diego-Carlsbad, CA', code: '41740' },
            { name: 'San Francisco-Oakland-Hayward, CA', code: '41860' },
            { name: 'San Jose-Sunnyvale-Santa Clara, CA', code: '41940' },
            { name: 'San Luis Obispo-Paso Robles-Arroyo Grande, CA', code: '42020' },
            { name: 'Santa Cruz-Watsonville, CA', code: '42100' },
            { name: 'Santa Fe, NM', code: '42140' },
            { name: 'Santa Maria-Santa Barbara, CA', code: '42200' },
            { name: 'Santa Rosa, CA', code: '42220' },
            { name: 'Savannah, GA', code: '42340' },
            { name: 'Scranton–Wilkes-Barre–Hazleton, PA', code: '42540' },
            { name: 'Seattle-Tacoma-Bellevue, WA', code: '42660' },
            { name: 'Sebastian-Vero Beach, FL', code: '42680' },
            { name: 'Sebring, FL', code: '42700' },
            { name: 'Sheboygan, WI', code: '43100' },
            { name: 'Sherman-Denison, TX', code: '43300' },
            { name: 'Shreveport-Bossier City, LA', code: '43340' },
            { name: 'Sierra Vista-Douglas, AZ', code: '43420' },
            { name: 'Sioux City, IA-NE-SD', code: '43580' },
            { name: 'Sioux Falls, SD', code: '43620' },
            { name: 'South Bend-Mishawaka, IN-MI', code: '43780' },
            { name: 'Spartanburg, SC', code: '43900' },
            { name: 'Spokane-Spokane Valley, WA', code: '44060' },
            { name: 'Springfield, IL', code: '44100' },
            { name: 'Springfield, MA', code: '44140' },
            { name: 'Springfield, MO', code: '44180' },
            { name: 'Springfield, OH', code: '44220' },
            { name: 'St. Cloud, MN', code: '41060' },
            { name: 'St. George, UT', code: '41100' },
            { name: 'St. Joseph, MO-KS', code: '41140' },
            { name: 'St. Louis, MO-IL', code: '41180' },
            { name: 'State College, PA', code: '44300' },
            { name: 'Staunton-Waynesboro, VA', code: '44420' },
            { name: 'Stockton-Lodi, CA', code: '44700' },
            { name: 'Sumter, SC', code: '44940' },
            { name: 'Syracuse, NY', code: '45060' },
            { name: 'Tallahassee, FL', code: '45220' },
            { name: 'Tampa-St. Petersburg-Clearwater, FL', code: '45300' },
            { name: 'Terre Haute, IN', code: '45460' },
            { name: 'Texarkana, TX-AR', code: '45500' },
            { name: 'The Villages, FL', code: '45540' },
            { name: 'Toledo, OH', code: '45780' },
            { name: 'Topeka, KS', code: '45820' },
            { name: 'Trenton, NJ', code: '45940' },
            { name: 'Tucson, AZ', code: '46060' },
            { name: 'Tulsa, OK', code: '46140' },
            { name: 'Tuscaloosa, AL', code: '46220' },
            { name: 'Tyler, TX', code: '46340' },
            { name: 'Urban Honolulu, HI', code: '46520' },
            { name: 'Utica-Rome, NY', code: '46540' },
            { name: 'Valdosta, GA', code: '46660' },
            { name: 'Vallejo-Fairfield, CA', code: '46700' },
            { name: 'Victoria, TX', code: '47020' },
            { name: 'Vineland-Bridgeton, NJ', code: '47220' },
            { name: 'Virginia Beach-Norfolk-Newport News, VA-NC', code: '47260' },
            { name: 'Visalia-Porterville, CA', code: '47300' },
            { name: 'Waco, TX', code: '47380' },
            { name: 'Walla Walla, WA', code: '47460' },
            { name: 'Warner Robins, GA', code: '47580' },
            { name: 'Washington-Arlington-Alexandria, DC-VA-MD-WV', code: '47900' },
            { name: 'Waterloo-Cedar Falls, IA', code: '47940' },
            { name: 'Watertown-Fort Drum, NY', code: '48060' },
            { name: 'Wausau, WI', code: '48140' },
            { name: 'Weirton-Steubenville, WV-OH', code: '48260' },
            { name: 'Wenatchee, WA', code: '48300' },
            { name: 'Wheeling, WV-OH', code: '48540' },
            { name: 'Wichita Falls, TX', code: '48660' },
            { name: 'Wichita, KS', code: '48620' },
            { name: 'Williamsport, PA', code: '48700' },
            { name: 'Wilmington, NC', code: '48900' },
            { name: 'Winchester, VA-WV', code: '49020' },
            { name: 'Winston-Salem, NC', code: '49180' },
            { name: 'Worcester, MA-CT', code: '49340' },
            { name: 'Yakima, WA', code: '49420' },
            { name: 'York-Hanover, PA', code: '49620' },
            { name: 'Youngstown-Warren-Boardman, OH-PA', code: '49660' },
            { name: 'Yuba City, CA', code: '49700' },
            { name: 'Yuma, AZ', code: '49740' }
        ];
        return data;
    }
}

